/** Copyright 2025 Midas Healthcare Solutions - All Rights Reserved **/
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserState, USER_KEY } from './user.reducer';
import { GeneralSetting, SettingsGroup, SettingsGroups } from '@midas/shared/common';

const getState = createFeatureSelector<UserState>(USER_KEY);

export const getUserState = createSelector(getState, (state: UserState) => state);

export const getUserAlibiSetting = (settingsGroup: SettingsGroup) =>
  createSelector(getState, (state: UserState) => {
    return state.alibiSettings.find((s) => s.settingsGroup === settingsGroup)?.settings ?? '{}';
  });

export const getUserAlibiGeneralSetting = (generalSetting: GeneralSetting) =>
  createSelector(getState, (state: UserState) => {
    const generalSettings = state.alibiSettings.find(
      (s) => s.settingsGroup === SettingsGroups.GeneralSettings,
    );
    if (!generalSettings) return null;

    const parsedJson = JSON.parse(generalSettings.settings);
    return generalSetting in parsedJson ? parsedJson[generalSetting] : null;
  });
